import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ValidatorService } from './validator.service';

@Injectable()
export class DefaultValidatorService implements ValidatorService {

    // Taken From https://github.com/irossimoline/angular4-material-table //

  getRowValidator(): FormGroup {
    return new FormGroup({});
  }
}
